<i class="fas fa-star default-calendar-indicator"
   [ngStyle]="{display: !isDefaultCalendarView ? 'none': 'inline'}"
   (click)="setAsDefaultCalendarView()"
   [matTooltip]="isDefaultCalendarView? 'Default': 'Set this calendar as default'"
   [matTooltipPosition]="tooltipPosition"
   matTooltipClass="text-center"></i>
